//Le reducer a besoin de 2 éléments pour fonctionner
//1. l'action (l'info sur ce qui se passe
//2. une copie du state actuel


export default function profilesave(state = [], action) {
  if (action.type === 'save') {
    var inputsCopy = Object.assign({}, state);
    inputsCopy.firstName = action.values.firstName;
    inputsCopy.lastName = action.values.lastName;
    inputsCopy.nickName = action.values.nickName;
    inputsCopy.email = action.values.email;
    inputsCopy.dateOfBirth = action.values.birthDate;
    inputsCopy.weight = action.values.weight;
    inputsCopy.height = action.values.height;
    inputsCopy.adresse = action.values.adresse;
    inputsCopy.phone = action.values.phone;
    inputsCopy.professional = action.values.professional;
    inputsCopy.levelValue = action.values.level;
    inputsCopy.gender = action.values.gender;
    inputsCopy.speedValue = action.values.speed;
    inputsCopy.availabilities = action.values.availabilities;
    inputsCopy.desc = action.values.desc;
    inputsCopy.description = action.values.description;
    return inputsCopy;
  }
  else {
    return state
  }
}
